import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            深度策划的专题内容，聚焦娱乐圈最值得关注的议题
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item, i) => (
            <article
              key={i}
              className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-colors duration-300 group cursor-pointer"
            >
              <div className="relative w-full aspect-[2/1] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={`吃瓜在线 - ${item.title}`}
                  title={`${item.title} - 吃瓜在线焦点专题`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute top-4 left-4">
                  <span className="inline-block px-3 py-1 rounded-lg bg-accent-500/90 text-white text-xs font-semibold whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-3 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.summary}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}